import React from "react";
import { Route, withRouter } from "react-router";
import { connect } from "react-redux";
import { History } from "history";
import _ from "lodash";

import { URLS, SIDE_MENUS, HIDED_SIDE_MENUS } from "constants/urlConstants";
import IUser from "models/IUser";
import PageLayout from "components/PageLayout";
import AuthManager from "./auth-manager";
import { configurationsFromFile } from "../../apiUtils";

interface IProps {
  user: IUser;
  roles: string[];
  component: any;
  isAppLoading: boolean;
  sessionExpired: boolean;
  history: History;
  withoutLayout?: boolean;
}

interface IState {
  retryCount: number;
  countdown: number;
}

class AuthRoute extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    console.log("intializing auth manager");
    // .then((config: any) => {
    //   console.log("In auth Route => ", { config });
    setTimeout(async () => {
      configurationsFromFile().then((res) => {
        AuthManager(res).initialize();
      });
    }, 0);

    // });
  }
  public componentWillReceiveProps(nextProps) {
    const { user, roles, path, history } = nextProps;
    const menuItems = _.concat(
      _.flatMap(SIDE_MENUS, "items"),
      HIDED_SIDE_MENUS
    );
    const currentPageRoles = _.get(_.find(menuItems, ["url", path]), "roles");

    if (
      currentPageRoles &&
      _.intersection(currentPageRoles, roles).length === 0 &&
      user !== null
    ) {
      history.push(URLS.HOME_URL);
    }
  }

  public render() {
    const {
      user,
      component: Component,
      isAppLoading,
      sessionExpired,
      history,
      withoutLayout,
      ...routeParams
    } = this.props;

    return user ? (
      <Route
        {...routeParams}
        render={(matchProps) =>
          withoutLayout ? (
            <Component {...matchProps} />
          ) : (
            <PageLayout isLoading={isAppLoading} history={history}>
              <Component {...matchProps} />
            </PageLayout>
          )
        }
      />
    ) : (
      <>{<div className="fixed-loading" />}</>
    );
  }
}

export default withRouter<any>(
  connect((state) => ({
    user: state.app.user,
    isAppLoading: state.app.isAppLoading,
    sessionExpired: state.app.sessionExpired,
    roles: state.app.roles,
  }))(AuthRoute)
);
